export default __webpack_public_path__ + "static/media/Drum-kit-web-game.aa7e7290.png";